import { motion } from 'framer-motion'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card.jsx'
import { Button } from '@/components/ui/button.jsx'
import { Badge } from '@/components/ui/badge.jsx'
import { TypographyH3, TypographySmall, TypographySmallMuted, TypographyXSmallMuted } from '@/components/ui/typography.jsx'

export const PlanCard = ({ plan, cycle, onPlanChosen, currentSubscription }) => {


    const price = plan.cycles[cycle].price
    const badge = plan.badge
    const isCurrentSubscriptionPlan = currentSubscription?.plan === plan._id

    return (
         <Card
             className={`flex flex-col justify-between w-72 relative overflow-hidden h-full ${plan.isPreferred ? 'border-primary' : '' }`}
         >
             {
                 badge && (
                     <motion.div
                         initial={{ opacity: 0, right: "-50px" }}
                         animate={{ opacity: 1, right: 0 }}
                         className="relative"
                     >
                        <Badge variant="secondary" className="absolute top-4 right-4 bg-secondary-100/50 border-secondary text-secondary hover:bg-secondary-100/50">{badge}</Badge>
                     </motion.div>
                )
             }
             <CardHeader>
                 <CardTitle className="text-xl font-semibold">{plan.name}</CardTitle>
                 <CardDescription>{plan.description}</CardDescription>
             </CardHeader>
             <CardContent>
                 <TypographyH3 className="flex items-end gap-1">
                     ${price}
                     <TypographyXSmallMuted>/ Per Month, Billed {cycle === 'annually' ? 'Yearly' : 'Monthly'}</TypographyXSmallMuted>
                 </TypographyH3>

                 <ul className="mt-4 space-y-2">
                     {plan.features.map((feature, idx) => (
                         <li key={idx} className="flex items-center">
                             <svg
                                 className="mr-2 h-4 w-4 text-green-500"
                                 fill="none"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth="2"
                                 viewBox="0 0 24 24"
                                 stroke="currentColor"
                             >
                                 <path d="M5 13l4 4L19 7"></path>
                             </svg>
                             <TypographySmall>
                                 {feature}
                             </TypographySmall>
                         </li>
                     ))}
                 </ul>
             </CardContent>
             <CardFooter>
                 <Button
                     disabled={isCurrentSubscriptionPlan}
                     className="w-full bg-gradient-to-r from-[#f08080] to-[#e35d5d] hover:from-[#f29292] hover:to-[#d54e4e] text-white transition-all"
                     onClick={() => onPlanChosen(plan, cycle)}
                 >
                     {isCurrentSubscriptionPlan ? 'Current' : 'Choose Plan'}
                 </Button>
             </CardFooter>
         </Card>
     )
}